const state = {
    taskList: [],//素材
    workTaskList: [],//工单
    showQueueModal: '',
    isCreateWorkOrdering:false,     // 用来记录是否在创建页面&离开时是否需要提示
    // routeList: []
    routeList: sessionStorage.getItem('routeList') ? JSON.parse(sessionStorage.getItem('routeList')) : [], // 工单路由列表 处理返回参数的记录  同时记录再stroge里
};

const mutations = {
    ADD_TASK_ITEM(state, playload) {
        playload.t = Date.now()
        state.taskList.push(playload)
    },
    ADD_WORK_TASK_ITEM(state, playload) {
        playload.t = Date.now()
        state.workTaskList.push(playload)
    },
    // 删除素材任务
    DEL_TASK_ITEM(state, playload) {
        const index = state.taskList.indexOf(playload);
        if (index > -1) {
            state.taskList.splice(index, 1)
        }
    },
    // 删除工单任务
    DEL_WORK_TASK_ITEM(state, playload) {
        const index = state.workTaskList.indexOf(playload);
        if (index > -1) {
            state.workTaskList.splice(index, 1)
        }
    },
    // 更新 创建页面状态
    UPDATE_CREATE_PAGE_STATUS(state, playload) {
        state.isCreateWorkOrdering = playload;
    },
    // 显示影藏处理中心
    SET_SHOW_QUEUE_MODAL(state, playload) {
        state.showQueueModal = playload;
    },
    // 添加路由列表
    SET_ROUTE_LIST(state, playload) {
        state.routeList.push(playload);
        sessionStorage.setItem('routeList', JSON.stringify(state.routeList));
    },
    // 删除路由列表 最后一个
    REMOVE_LAST_ITEM(state) {
        state.routeList.pop();
        localStorage.setItem('routeList', JSON.stringify(state.routeList));
    },
};
const actions = {
    // 添加素材提交任务
    ADD_TASK_ITEM({ commit }, playload) {
        console.log(playload, 'ADD_TASK_ITEMplayload');
        commit('ADD_TASK_ITEM', playload)
    },
    // 添加工单任务
    ADD_WORK_TASK_ITEM({ commit }, playload) {
        console.log(playload, 'ADD_WORK_TASK_ITEMplayload');
        commit('ADD_WORK_TASK_ITEM', playload)
    },
    // 添加 路由列表
    ADD_ROUTE_LIST({ commit }, playload) {
        console.log('---', playload)
        commit('SET_ROUTE_LIST', playload)
    },
    // 获取最后一个路由并删除
    READ_ROUTE_LIST({state, commit }) {
        const routeList = JSON.parse(sessionStorage.getItem('routeList')) || [];
        const lastItem = state.routeList[state.routeList.length - 1]
        console.log('lastItem',state.routeList)
        commit('REMOVE_LAST_ITEM')
        return Promise.resolve(lastItem)
    },
    // 清空缓存
    CLEAR_ROUTE_CACHE({ commit }) {
        sessionStorage.removeItem('routeList');
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
